export const DASHBOARD_ROUTES = {
  GET: {
    dashboard: '/projects/:pid/dashboard'
  }
};

export const ACCOUNT_ROUTES = {
  GET: {
    account: '/account'
  }
};

export const PROJECTS_ROUTES = {
  GET: {
    projects: '/projects',
    project: '/projects/:id',
    project_roles: '/project_roles'
  },
  POST: {},
  PUT: {
    project: '/projects/:pid'
  },
  DELETE: {}
};

export const PROJECTS_FILES_ROUTES = {
  GET: {
    project_files: '/project_files',
    project_file: '/project_files/:pfid'
  },
  POST: {
    project_files: '/project_files'
  },
  PUT: {
    project_files: '/project_files/:pfid'
  },
  DELETE: {
    project_files: '/project_files/:pfid'
  }
};

export const QUOTATIONS_ROUTES = {
  GET: {
    quotations: '/quotations',
    quotation: '/quotations/:qid',
    quotation_version_download: '/quotations/:qid/versions/:vid/print'
  },
  POST: {
    quotation: '/projects/:id/quotations'
  },
  PUT: {
    quotation_version: '/quotations/:qid/versions/:vid'
  },
  DELETE: {
    quotation: '/quotations/:qid'
  }
};

export const QUOTATION_VERSIONS_ROUTES = {
  GET: {
    quotation_versions: '/quotation_versions',
    quotation_version: '/quotation_versions/:vid',
    quotation_financial: '/quotation_versions/:vid/financials',
    download_contract_engagement: '/quotation_versions/:vid/download_engagement',
    construction_contract: '/quotation_versions/:vid/construction_contract',
    download_version: '/quotation_versions/:vid/print'
  },
  POST: {
    create_version: '/quotation_versions',
    duplicate_version: '/quotation_versions/:vid/duplicate',
    generate_contract_engagement: '/quotation_versions/:vid/generate_engagement',
    share_version: '/quotation_versions/:vid/share',
    publish_version: '/quotation_versions/:vid/publication'
  },
  PUT: {
    quotation_versions: '/quotation_versions/:vid',
    sign_engagement: '/quotation_versions/:vid/sign_engagement',
    sign_contract: '/quotation_versions/:vid/sign_contract',
    sign_amendement: '/quotation_versions/:vid/sign_amendement'
  },
  DELETE: {
    quotation_versions: '/quotation_versions/:vid'
  }
};

export const QUOTATION_CHAPTERS_ROUTES = {
  GET: {
    quotation_chapters: '/quotation_chapters',
    quotation_chapter: '/quotation_chapters/:cid',
    search_quotation_chapters: '/quotation_chapters'
  },
  POST: {
    create_chapter: '/quotation_chapters',
    duplicate_chapter: '/quotation_chapters/:cid/duplicate'
  },
  PUT: {
    quotation_chapters: '/quotation_chapters/:cid'
  },
  DELETE: {
    quotation_chapters: '/quotation_chapters/:cid'
  }
};

export const QUOTATION_SERVICES_ROUTES = {
  GET: {
    quotation_services: '/quotation_services',
    quotation_service: '/quotation_services/:sid',
    search_quotation_services: '/quotation_services'
  },
  POST: {
    create_service: '/quotation_services',
    duplicate_services: '/quotation_services/:sid/duplicate',
    disable_service: '/quotation_services/:sid/disable',
    enable_service: '/quotation_services/:sid/enable'
  },
  PUT: {
    quotation_services: '/quotation_services/:sid'
  },
  DELETE: {
    quotation_services: '/quotation_services/:sid'
  }
};

export const QUOTATION_MATERIALS_ROUTES = {
  GET: {
    quotation_materials: '/quotation_materials',
    quotation_material: '/quotation_materials/:mid'
  },
  POST: {
    create_materials: '/quotation_materials'
  },
  PUT: {
    update_materials: '/quotation_materials/:mid'
  },
  DELETE: {
    quotation_materials: '/quotation_materials/:mid'
  }
};

export const MATERIALS_ROUTES = {
  GET: {
    materials: '/materials',
    material: '/materials/:mid',
    search_materials: '/materials',
    top: '/materials/top'
  },
  POST: {
    create_materials: '/materials'
  },
  PUT: {
    material: '/materials/:mid'
  },
  DELETE: {
    delete: '/materials/:mid'
  }
};

export const UNITS_TYPES_ROUTES = {
  GET: {
    unit_types: '/unit_types'
  },
  POST: {},
  PUT: {},
  DELETE: {}
};

export const INVOICES_ROUTES = {
  GET: {
    invoices: '/invoices',
    invoice: '/invoices/:id',
    printInvoice: '/invoices/:id/print'
  },
  POST: {
    invoices: '/invoices'
  },
  PUT: {
    invoices: '/invoices/:id'
  },
  DELETE: {
    invoices: '/invoices/:id'
  }
};

export const PROJECT_PAYMENTS_ROUTE = {
  GET: {
    project_payments: '/project_payments',
    project_payment: '/project_payments/:id'
  },
  POST: {
    project_payments: '/project_payments'
  },
  PUT: {
    project_payments: '/project_payments/:id'
  },
  DELETE: {
    project_payments: '/project_payments/:id'
  }
};

export const TRANSACTIONS_ROUTES = {
  GET: {
    transactions: '/transactions',
    transaction: '/transactions/:id'
  },
  POST: {
    transactions: '/transactions'
  },
  PUT: {
    transactions: '/transactions/:id'
  },
  DELETE: {
    transactions: '/transactions/:id'
  }
};

export const PROJECT_MATERIALS_ROUTES = {
  GET: {
    project_materials: '/project_materials',
    project_material: '/project_materials/:id'
  },
  POST: {
    project_materials: '/project_materials'
  },
  PUT: {
    project_materials: '/project_materials/:id'
  },
  DELETE: {
    project_materials: '/project_materials/:id'
  }
};

export const STEP_CATEGORIES_ROUTES = {
  GET: {
    step_categories: '/step_categories'
  }
};

export const STEPS_ROUTES = {
  GET: {
    steps: '/steps/'
  }
};

export const FILES_ROUTES = {
  GET: {
    files: '/files',
    file: '/files/:fid'
  },
  PUT: {
    files: '/files/:fid'
  },
  POST: {
    files: '/files'
  },
  DELETE: {
    files: '/files/:fid'
  }
};

export const PLANNINGS_ROUTES = {
  GET: {
    plannings: '/plannings',
    planning: '/plannings/:pid'
  },
  POST: {
    planning: '/plannings'
  },
  PUT: {
    planning: '/plannings/:pid'
  }
};

export const PROJECT_SUBJECTS_ROUTE = {
  GET: {
    listsubjects: '/project_subjects',
    subject_attachment: '/project_subjects/:sid/attachment',
    print_subjects: '/project_subjects/print'
  },
  POST: {
    subject: '/project_subjects'
  },
  DELETE: {
    subject: '/project_subjects/:sid'
  },
  PUT: {
    subject: '/project_subjects/:sid'
  }
};

export const NOTIFICATIONS_ROUTES = {
  GET: {
    notifications: '/notifications'
  },
  POST: {
    notifications: '/notifications'
  }
};

export const PROJECTS_ROOMS_ROUTE = {
  GET: {
    project_rooms: '/project_rooms'
  },
  PUT : {
    project_rooms: '/project_rooms/:id'
  },
  POST: {
    project_rooms: '/project_rooms'
  },
  DELETE: {
    project_rooms: '/project_rooms/:id'
  }
};

export const QUOTATION_MATERIAL_VALIDATIONS_ROUTE = {
  GET : {
    quotation_material_validation: '/quotation_material_validations'
  },
  POST: {
    quotation_material_validation: '/quotation_material_validations'
  }
};
